import { Dialog } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useMemo } from "react";
import { SelectBoxOption } from "../../interfaces";
import { useAppSelector } from "../../redux";
import { useLazyGetNounsDDQuery } from "../../redux/services";
import { HasAccess } from "../../router/authorization";
import { PERMISSIONS } from "../../router/permission";
import { AddUpdateNoun } from "../../screens/mdUpdate/addUpdate";
import { HighlightSelectBox, HighlightSelectProps } from "../highLightSelectBox";
import { sortingOption } from "../regionSelect";

type common = string | number | boolean | undefined;

const NounSelect: React.FC<HighlightSelectProps & { groupId: common; uomId: common; updateNoun: (d: SelectBoxOption | null) => void }> = ({ groupId, uomId, updateNoun, ...props }) => {

    const { perm } = useAppSelector(store => store.auth.userDetails);
    const { enqueueSnackbar } = useSnackbar();

    const creatable = React.useMemo(() => HasAccess(perm, PERMISSIONS.MATERIAL_REPO_EDIT), [perm]);
    const readable = React.useMemo(() => HasAccess(perm, PERMISSIONS.MATERIAL_REPO_READ), [perm]);

    const enableAdd = creatable && readable;

    const [getNouns, nounData] = useLazyGetNounsDDQuery();

    const nounOptions = useMemo(() => {
        return nounData?.currentData?.filter((_: any) => _.group_id === groupId && _.uom_id === uomId) ?? [];
        // eslint-disable-next-line
    }, [groupId, uomId, nounData.status]);

    const [open, setOpen] = React.useState<boolean>(false);

    const refetch = async (res: { _id: string, value: string }) => {
        updateNoun({ _id: res?._id, value: res?._id, label: res.value });
        getNouns(sortingOption("noun_name"));
    }

    const onAddBtnClick = () => {
        setOpen(true);
    };

    useEffect(() => {
        getNouns(sortingOption("noun_name"));
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (!(groupId && uomId)) {
            updateNoun(null);
        }
        // eslint-disable-next-line
    }, [groupId, uomId]);

    useEffect(() => {
        if (nounData.isError) {
            enqueueSnackbar("Oops! Something went wrong, Unable to fetch Nouns", { variant: "error" })
        }
        // eslint-disable-next-line
    }, [nounData.status])

    return (<>
        <HighlightSelectBox
            {...props}
            options={nounOptions}
            value={nounOptions.find(n => n?._id === (props.value as SelectBoxOption)?.value) || null}
            loading={nounData?.isFetching || nounData?.isLoading}
            newOptionCreationProps={enableAdd ? {
                title: "Create New Noun",
                onAddBtnClick
            } : undefined}
        />

        <Dialog open={open} onClose={() => setOpen(false)}>
            <AddUpdateNoun isEdit={false} data={null} refetch={refetch} onCancel={() => setOpen(false)} />
        </Dialog>
    </>)
}

export default NounSelect;